/** RevenueCat entitlement that unlocks MintStint Pro. */
export const MINTSTINT_PRO_ENTITLEMENT = "MintStint Pro";

/** Current offering lookup key in the RevenueCat dashboard. */
export const MINTSTINT_DEFAULT_OFFERING = "default";

/** Store product identifier for the NZ monthly plan. */
// Matches the fleet convention (<product>_pro_monthly). The RevenueCat
// product and the store product must be renamed to match before release —
// the offering lookup fails if they diverge.
export const MINTSTINT_MONTHLY_PRODUCT_ID = "mintstint_pro_monthly";
